import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import * as Layout from 'layouts/StepperLayout';
import { LegacySpacing } from 'theme/legacyTheme';

export const Title = styled(Heading).attrs({ size: 'lg' })`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const Subtitle = styled(Text)`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs40}px;
`;

export const MastercardText = styled(Text).attrs({ variant: 'primary' })`
  padding-right: ${({ theme }) => theme.spacings.abs32}px;
`;

export const SidebarTitle = styled(Text).attrs({
  size: 'sm',
  type: 'light',
})``;

interface WarningBoxWrapperProps {
  marginTop?: LegacySpacing;
}
export const WarningBoxWrapper = styled.div<WarningBoxWrapperProps>`
  margin-top: ${({ marginTop = 'abs32', theme }) =>
    theme.spacings[marginTop]}px;
`;

export const FooterButtonsContainer = styled(Layout.FooterButtonsContainer)`
  align-items: center;
  justify-content: space-between;
`;
